import { type NexusApiActionDef } from "./action-def.types";
import { listOutput, obj } from "./output-format.builders";

export const taskActions: NexusApiActionDef[] = [
  {
    action: "tasks.list",
    label: "List Tasks",
    description: "List all AI tasks",
    inputSchema: {},
    outputFormat: listOutput("tasks")
  },
  {
    action: "tasks.get",
    label: "Get Task",
    description: "Get AI task details",
    inputSchema: {
      taskId: { type: "string", description: "Task ID" }
    },
    outputFormat: obj("Task details")
  },
  {
    action: "tasks.execute",
    label: "Execute Task",
    description: "Execute an AI task with input",
    inputSchema: {
      taskId: { type: "string", description: "Task ID" },
      taskInput: { type: "string", description: "Task input (text or JSON)" }
    },
    outputFormat: obj("Execution result")
  }
];
